import { useQuery } from '@tanstack/react-query'
import {
  getWebsiteTrackingAndSeo,
  GetWebsiteTrackingAndSeoResponse,
} from 'src/editor/api/website-pages-api'

export const websiteTrackingAndSeoQueryKey = (pageId: number) => [
  'websiteTrackingAndSeo',
  pageId,
]

type UpdaterType = (
  prevData: GetWebsiteTrackingAndSeoResponse,
) => GetWebsiteTrackingAndSeoResponse

export const setWebsiteTrackingAndSeoQueryDataArgs = (
  pageId: number,
  updater: UpdaterType,
): [readonly unknown[], UpdaterType] => [
  websiteTrackingAndSeoQueryKey(pageId),
  updater,
]

export const useQueryWebsiteTrackingAndSeo = (pageId: number) =>
  useQuery({
    queryKey: websiteTrackingAndSeoQueryKey(pageId),
    queryFn: () => getWebsiteTrackingAndSeo(pageId),
    staleTime: 1000 * 60 * 5,
  })
